import React, { useEffect, useRef, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getApiKey, getToken, isAutoAuthPending } from '../../Utility/Utility';

const hasUrlAuthParams = (search) => {
  const params = new URLSearchParams(search);
  return params.get('email') && params.get('password') && params.get('loginMode');
};

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const [, forceUpdate] = useState(0);
  const seenPendingTrueRef = useRef(false);
  const initialHasParamsRef = useRef(hasUrlAuthParams(location.search));

  useEffect(() => {
    seenPendingTrueRef.current = false;
    initialHasParamsRef.current = hasUrlAuthParams(location.search);
  }, [location.search, location.pathname]);

  useEffect(() => {
    const onStorage = () => forceUpdate((n) => n + 1);
    window.addEventListener('storage', onStorage);
    const interval = setInterval(() => forceUpdate((n) => n + 1), 150);
    return () => {
      window.removeEventListener('storage', onStorage);
      clearInterval(interval);
    };
  }, []);

  const token = getToken();
  const apiKey = getApiKey();
  const hasParams = hasUrlAuthParams(location.search);
  const pending = isAutoAuthPending();

  if (pending && !seenPendingTrueRef.current) seenPendingTrueRef.current = true;

  const authPending =
    (hasParams && (pending || (initialHasParamsRef.current && !seenPendingTrueRef.current && !token && !apiKey))) ||
    (hasParams && !token && !apiKey && !seenPendingTrueRef.current);

  if (authPending) {
    return (
      <div className="min-vh-100 d-flex align-items-center justify-content-center bg-light">
        <div className="text-center">
          <div className="spinner-border text-primary mb-3" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="text-muted">Authenticating...</p>
        </div>
      </div>
    );
  }

  if (!token && !apiKey) {
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }

  return children;
};

export default ProtectedRoute;
